export default __webpack_public_path__ + "static/1-36-0-and-or-filtering-f385c968830934be3ae68b40b52c2c13.png";